var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogo = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3164_1545)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#01BC9A",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2957 14.15C15.4528 13.9569 15.7517 13.942 15.9318 14.1165L17.1426 15.2936C15.2957 17.6366 11.805 18.1527 9.30672 16.3147C7.16094 14.7366 6.48272 11.8218 7.72804 9.50856C9.31438 6.56405 13.1576 5.69147 15.9088 7.55546V7.56288L14.7785 8.63226C14.5026 8.89218 14.1002 8.95902 13.7324 8.84762C12.1729 8.36863 10.3949 9.02957 9.62092 10.5817C8.97719 11.8775 9.29522 13.4779 10.3988 14.4433C11.851 15.7095 13.9891 15.5387 15.2191 14.2391C15.2249 14.2323 15.2314 14.2246 15.2385 14.2161C15.2549 14.1966 15.2744 14.1733 15.2957 14.15Z",
    fill: "#01BC9A",
    fillOpacity: 0.87
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3164_1545"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo.7d46587d11ec89b03895da6f3161ba76.svg";